<template>

    <div v-if="user">
      <Card>
      <div class="row">
        <div class="col-12 col-md-6">
          <h5 class="text-center font-weight-bold">اشتراک فروشنده </h5>
          <div v-if="user.is_seller">
            <div class="">اشتراک فعلی :
              {{(user.seller_plan?user.seller_plan.title:'--')}}
            </div>
            <div>تعداد سکه :
            {{user.seller_coin}}
            </div>
            <div>تعداد سکه فعال :
              {{user.active_seller_coin}}
            </div>
            <div>تاریخ انقضا :
              {{user.seller_expire_date}}
            </div>
          </div>
          <div v-else class="alert alert-danger">اشتراکی ثبت نشده است</div>
        </div>
        <div class="col-12 col-md-6">
          <h5 class="text-center font-weight-bold">اشتراک خریدار  </h5>
          <div v-if="user.is_buyer">
            <div class="">اشتراک فعلی :
              {{(user.buyer_plan?user.buyer_plan.title:'--')}}
            </div>
            <div>تعداد سکه :
              {{user.buyer_coin}}
            </div>
            <div>تعداد سکه فعال :
              {{user.active_buyer_coin}}
            </div>
            <div>تاریخ انقضا :
            {{user.buyer_expire_date}}
            </div>
          </div>
          <div v-else class="alert alert-danger">اشتراکی ثبت نشده است</div>
        </div>
      </div>
        <div class="mt-3 container">
          <ActivePlanUser :user_id="user._id" @successCallback="activePlanEvent" v-if="plans && plans.length" :plans="plans"></ActivePlanUser>
        </div>
      </Card>
      <Card>
        <div class="h5 font-weight-bold">تاریخچه اشتراک های فعال شده :</div>
        <LocalDataTable :ajax-link="ajaxLink" :columns="columns"></LocalDataTable>
      </Card>
    </div>
    <div class="alert alert-danger" v-if="error">{{error}}</div>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import {UserApi} from "@/api/UserApi";
import LocalDataTable from "@/components/LocalDataTable";
import {AppApi} from "@/api/AppApi";
import ActivePlanUser from "@/components/activePlanUser";
export default {
  name: "userPlanInfo",
  components: {ActivePlanUser, LocalDataTable, Card},
  data()
  {
    return{
      ajaxLink : '',
      columns : [
        {title : 'تاریخ'},{title : 'اشتراک'},{title : 'نوع'},{title: 'عنوان'},{title : 'تعداد سکه'},{title : 'تعداد روز'},{title : 'قیمت'},{title : 'توسط'}
      ],
      user : null,
      error : null,
      id : this.$route.params.id,
      plans : [],
    }
  },
  mounted()
  {
    this.setPageLoading(false);
    this.setPageTitle('');
    this.setShowHead(true);
    this.initPage();
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      const self = this;
      AppApi.getPlansForSelect().then(function (data)
      {
        if (data.ok)
        {
          self.plans = data.plans;
        }
      });
      this.setPageLoading(true);
      this.user = null;
      this.error = null;
      this.id = this.$route.params.id;
      this.ajaxLink = 'admin/user/planLogsList/'+this.id;
      const result = await UserApi.getUserInfoForEdit(this.id);
      if (result.ok)
      {
        this.user = result.user;
        let title = 'اطلاعات اشتراک های '+this.user.title;
        this.setPageTitle(title);
      }
      else
        this.error = result.error;
      this.setPageLoading(false);
    },
    async activePlanEvent(data)
    {
      if (data)
        this.initPage();
    }
  },

}
</script>

<style scoped>

</style>